import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PromoBannerContainer, Banner, BannerSection } from './styles';
import { useDomainConfig } from 'shared/domainConfig/context/context';
import { useAuthModalWrapperContext } from 'shared/components/AuthModal/AuthModalWrapperContext';
import { isLoggedIn } from 'shared/store/app/selectors';

const TitlePromotionalBanner = () => {
  const {
    COLOR: { PROMOTIONAL_BANNER, PROMOTIONAL_BANNER_TEXT },
  } = useDomainConfig();
  const { showBottomSheetAuth } = useAuthModalWrapperContext();
  const isUserLoggedIn = useSelector(isLoggedIn);

  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setResolved(true);
    }, 600);
  }, [isUserLoggedIn]);

  return (
    <PromoBannerContainer>
      <Banner
        bgColor={PROMOTIONAL_BANNER}
        onClick={
          isUserLoggedIn
            ? () => window.open('https://www.footlocker.co.in/cp/flx-rewards', '_self')
            : () => showBottomSheetAuth('', false)
        }
      >
        <BannerSection style={{ color: PROMOTIONAL_BANNER_TEXT }}>
          {resolved && (
            <>
              {isUserLoggedIn
                ? 'FLX Rewards: Xclusive offers just for you! Learn More.'
                : 'FLX Members Earn Points on Purchases | Sign Up!'}
            </>
          )}
        </BannerSection>
      </Banner>
    </PromoBannerContainer>
  );
};

export default memo(TitlePromotionalBanner);
